import React, { Fragment } from 'react'
import classNames from 'classnames/bind'
import { useHistory } from 'react-router-dom'

import styles from  './blog-home-page.module.scss'
import { FluidImage } from "components/shared/fluid-image/FluidImage";

// Import Data for Blog
import { designingSystemsForTheTeamData } from 'components/pages/blog/blogData/designingSystemsForTheTeamData'
import { managingExpectationsData } from 'components/pages/blog/blogData/managingExpectationsData'
import { accountabilityData } from 'components/pages/blog/blogData/accountabilityData'
import { buildingYourBrandData } from 'components/pages/blog/blogData/buildingYourBrandData'
import { workingEfficientlyData } from 'components/pages/blog/blogData/workingEfficientlyData'
import { earningFavorData } from 'components/pages/blog/blogData/earningFavorData'
import {NavLink} from "react-router-dom";


const cx = classNames.bind(styles)

export const BlogHomePage = () => {
    const history = useHistory()
    const blogs = [earningFavorData, workingEfficientlyData, designingSystemsForTheTeamData, buildingYourBrandData, accountabilityData, managingExpectationsData]

    const handleButtonClick = (route) => {
        history.push(route)
    }

    return (
        <div className={cx(["container", "blog-home-page"])}>
            <div className={cx("row")}>
                <h1 className={cx("col-12")}>The KeyStrokes Not Taken</h1>
            </div>

            <div className={cx("row")}>
                <p className={cx("col-12")}>The KeyStrokes Not Taken is about the journey developers take in the world of technology.
                    We are faced with many challenges: Technology that is always evolving, tight deadlines looming,
                    our own career growth, etc. My aim with this blog is to share my experiences and observations in the
                    hope that through this, people may be able to enhance their own careers.
                </p>


                <h2 className={cx("col-12")}>Recent Blogs</h2>

                {/*Loop through and display the heading/image/beginning text of the recent blogs with the date*/}
                {blogs.map( (blog, index) => {
                    return (
                        <Fragment key={index}>
                            <h3 className={cx(['col-12', 'col-md-6'])}>
                                <NavLink to={blog.webLink}>{blog.blogHeading}</NavLink>
                            </h3>
                            <div className={cx(['col-12', 'col-md-6'])}>
                                <span className={cx(['blog-date'])}>{blog.blogDate}</span>
                            </div>
                            <p className={cx(['col-12', 'blog-wrapper'])}>
                                {blog.mainImage && (
                                    <FluidImage altText={blog.mainImage.alt} image={blog.mainImage.image} />
                                )}
                                {blog.description[0]}
                                <span className={cx(['blog-background-fade'])}>
                                    <button className={cx(['primary-button', 'view-blog-button'])} title="Click to view" onClick={() => handleButtonClick(blog.webLink)}>View Blog</button>
                                </span>
                            </p>
                        </Fragment>
                    )
                })}
            </div>
        </div>
    )
}

export default BlogHomePage